// extracted by mini-css-extract-plugin
module.exports = {"loading-page":"gUS3bp_5","cube-wrapper":"ASWr6cpv","shadow":"qdrXQBDj","loading":"djmqIgsp","text":"DCSZ_gPr","light":"CvWLrBeW","dark":"nKoyYcK3"};